import { render, staticRenderFns } from "./historialRetiro.vue?vue&type=template&id=56143062&scoped=true"
import script from "./historialRetiro.vue?vue&type=script&lang=js"
export * from "./historialRetiro.vue?vue&type=script&lang=js"
import style0 from "./historialRetiro.vue?vue&type=style&index=0&id=56143062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56143062",
  null
  
)

export default component.exports